export const allDevicesDeclineGift = () => {
    var noGift = $('input[id^=no_gifts_]'),
        selectGift = $('input[id^=SelectFreeGift_]');
    noGift.on('change', function() {
        if ($(this).prop("checked") == true) {
            selectGift.prop('checked', '');
            selectGift.prop('disable', 'disable');
        };
    });
    noGift.on('change', function() {
        if ($(this).prop("checked") == false) selectGift.prop('disable', false);
    });
};
